export default{
    setAppData(state,payload){
        state.appData=payload.Data;
    }
};